// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#my-account-dropzone[data-v-2786ac9d]{min-height:120px}#my-account-add-files[data-v-2786ac9d]{padding-top:40px}.dz-uploaded-file[data-v-2786ac9d]{cursor:default}.dz-uploaded-file .dz-thumbnail[data-v-2786ac9d]{width:0;margin-right:0}", ""]);
// Exports
module.exports = exports;
